import { updated } from '$app/state';

// A tab opened before a deploy asks for chunk names the new deployment no longer
// serves. Reload only on a confirmed new version (a flaky network would loop) and
// never mid-take (the reload would discard the recording).
export function reloadOnStaleChunk(inTake: () => boolean): () => void {
  const onPreloadError = async (): Promise<void> => {
    if ((await updated.check()) && !inTake()) location.reload();
  };
  window.addEventListener('vite:preloadError', onPreloadError);
  return () => window.removeEventListener('vite:preloadError', onPreloadError);
}
